<div class="root">
    <p *ngIf="label">{{label | translate}} <span *ngIf="required" class="required-asterisk">*</span></p>
    <div class="input-container">
        <input [formControl]="control" [matDatepicker]="picker" [max]="maxDate" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
    </div>
</div>